module.exports = __webpack_public_path__ + "static/media/star.e65238b8.svg";